import { Grid } from "@material-ui/core";
import * as React from "react";
import { useEffect, useState } from "react";
import { ErrorModal } from "../../../components/modals/error-modal";
import { LazyLoading } from "../../../controls/LazyLoading/LazyLoading";
import { TableShiftsCrews } from "./components/TableShifts";
import { useShiftsCrewsContext } from "./context/ShiftsCrewsContext";
import { getShiftParameters } from "./repositories/ShiftsCrewsRepository";

type Props = {};

export const ShiftsCrews = (prop: Props) => {
	const [isLoading, setIsLoading] = useState(true);
	const [error, setError] = useState("");
	const {
		state: { shifts },
		actions: { setShiftsCrews },
	} = useShiftsCrewsContext();

	const getShiftsCrewsFromAPI = async () => {
		setIsLoading(true);
		const resp = await getShiftParameters();
		if (resp.ok) {
			setShiftsCrews(resp.data.tables[0].rows);
			setIsLoading(false);
		} else {
			setError(resp.message);
			setIsLoading(false);
		}
	};

	useEffect(() => {
		getShiftsCrewsFromAPI();
	}, []);

	// Decided on isLoading, not on shifts.length: with no shift parameters configured the table is
	// empty, and treating empty as "still loading" left the spinner up forever. The create button
	// lives inside TableShiftsCrews, so hiding the table also made the first shift impossible to add.
	if (isLoading) {
		return (
			<>
				<Grid
					container
					justifyContent="center"
					alignItems="center"
					style={{ height: "70vh", width: "100%" }}
				>
					<LazyLoading />
				</Grid>
			</>
		);
	}
	return (
		<>
			<Grid container justifyContent="center" alignItems="center">
				<ErrorModal error={error} onHide={() => setError("")} />
				<div style={{ width: "100%", padding: "10px 0 20px" }}>
					<TableShiftsCrews
						isLoading={isLoading}
						getShiftsCrewsFromAPI={getShiftsCrewsFromAPI}
					/>
				</div>
			</Grid>
		</>
	);
};
